import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { uiActions } from "../../store/ui/ui-slice";
import { dispatch } from "../../store";

const GetLocalStorage = () => {
  const token = useSelector((state) => state.user?.token);

  if (!token) {
    return <Outlet />;
  }

  dispatch(uiActions.setLoading(false));
  dispatch(uiActions.setFormSubmitLoading(false));

  return <Navigate to="/" />;
};

export default GetLocalStorage;
